const availabilities = {
  few: process.env.VITE_SUITEBOOK_AVAILABILITY_FEW ?? 50,
  occupied: process.env.VITE_SUITEBOOK_AVAILABILITY_OCCUPIED ?? 0,
}

export type Availability = 'vacant' | 'few' | 'occupied' | 'notAvailable'

type RateInput = { rate: number | null; count?: never }
type CountInput = { count: number | null; rate?: never }
type Input = RateInput | CountInput

const isCountInput = (input: Input): input is CountInput => 'count' in input

const judgeByRate = (rate: number | null): Availability => {
  if (rate == null) return 'notAvailable'
  if (rate > Number(availabilities.few)) return 'vacant'
  if (rate > Number(availabilities.occupied)) return 'few'
  return 'occupied'
}

const judgeByCount = (count: number | null): Availability => {
  if (count == null) return 'notAvailable'
  if (count <= 0) return 'occupied'
  if (count <= 3) return 'few'
  return 'vacant'
}

export const isSoldOut = (availability: Availability): boolean =>
  availability === 'notAvailable' || availability === 'occupied'

export const getAvailability = (input: Input): Availability =>
  isCountInput(input) ? judgeByCount(input.count) : judgeByRate(input.rate)

export const useAvailability = (input: Input): Availability =>
  getAvailability(input)
